import { SettingsCache } from '~/lib/consts/settings-cache';

export function toDisplayCurrency(currencyCode: string, amount: number, minimumFractionDigits: number = 2) {
  return (amount ?? 0).toLocaleString(undefined, {
    style: 'currency',
    currency: currencyCode ?? SettingsCache.currencyCode,
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: 2,
    currencyDisplay: 'narrowSymbol'
  });
}

export function displayCurrencySymbol(currencyCode: string = null) {
  return (0)
    .toLocaleString(undefined, {
      style: 'currency',
      currency: currencyCode ?? SettingsCache.currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      currencyDisplay: 'narrowSymbol'
    })
    .replace(/[\d.,]/g, '');
}
